const STORAGE_KEY = 'trendive-exit-intent-popup-shown';
const MIN_TIME_ON_PAGE_MS = 4000;
// Phones/tablets have no mouse, so a "cursor leaves the top of the screen"
// signal never fires there. Fall back to a timed trigger on those devices.
const IS_TOUCH_DEVICE = window.matchMedia('(hover: none), (pointer: coarse)').matches;
const MOBILE_FALLBACK_DELAY_MS = 15000;

function alreadyShownThisSession() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function markShown() {
  try {
    sessionStorage.setItem(STORAGE_KEY, 'true');
  } catch (error) {
    // Ignore storage errors (e.g. private browsing)
  }
}

function anotherDialogIsOpen() {
  return Boolean(document.querySelector('dialog[open]'));
}

const popup = document.getElementById('exit-intent-popup');

if (popup && !alreadyShownThisSession()) {
  const pageLoadTime = Date.now();

  /** @param {MouseEvent} event */
  const handleMouseOut = (event) => {
    // Only fires when the cursor actually leaves the top edge of the viewport
    // (heading toward the tab bar / address bar / another window) — a reliable
    // exit-intent signal, unlike a generic mouseleave anywhere on the page.
    if (event.clientY > 0) return;
    if (Date.now() - pageLoadTime < MIN_TIME_ON_PAGE_MS) return;
    if (anotherDialogIsOpen()) return;
    if (typeof popup.showDialog !== 'function') return;

    popup.showDialog();
    markShown();
    document.removeEventListener('mouseout', handleMouseOut);
  };

  popup.addEventListener('dialog:close', markShown);

  if (IS_TOUCH_DEVICE) {
    setTimeout(() => {
      if (alreadyShownThisSession() || anotherDialogIsOpen()) return;
      if (typeof popup.showDialog !== 'function') return;

      popup.showDialog();
      markShown();
    }, MOBILE_FALLBACK_DELAY_MS);
  } else {
    document.addEventListener('mouseout', handleMouseOut);
  }
}
